import React, { useEffect, useRef, useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { PickingContextProvider } from "../PickingContext"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, TextField, InputLabel, Button, Typography } from "@mui/material"
import GridPickingSearch from "./GridPickingSearch"
import BackIcon from "../../../components/BackIcon"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery } from "@tanstack/react-query"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import EjecutarIcon from "../../../assets/iconos/EjecutarAccion.ico"
import ImpresionIcon from "../../../assets/iconos/Impresion.ico"
import DetalleImpresionSearch from "../../SolicitudDeIngreso/components/DetalleImpresionSearch"
import CustomTooltip from "../../../components/ToolTip"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import ExpandMore from "@mui/icons-material/ExpandMore"
import CustomAutoComplete from "../../SolicitudDeIngreso/components/CustomAutoComplete"
import CustomAutocomplete from "../../../components/CustomAutocomplete"
import useDebounce from "../../SolicitudDeIngreso/components/Debounce"
import dayjs from "dayjs"

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87",
    },
  },
})

const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Egreso Egreso Egreso Egreso Transferencia Transferencia Transferencia Transferencia Ingreso Ingreso Ingreso Ingreso"
    "FechaI FechaI FechaI FechaI FechaF FechaF FechaF FechaF Detalle Detalle Detalle Detalle"
    "Articulo Articulo Articulo Articulo Cliente Cliente Cliente Cliente Bodega Bodega Bodega Bodega"
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: `
      "Egreso Egreso Transferencia Transferencia Ingreso Ingreso"
      "FechaI FechaI FechaI FechaF FechaF FechaF"
      "Detalle Detalle Detalle Detalle Detalle Detalle"
      "Articulo Articulo Articulo Cliente Cliente Cliente"
      "Bodega Bodega Bodega Bodega Bodega Bodega"
    `,
  },
}))

const Egreso = styled(Box)({
  gridArea: "Egreso",
})

const Transferencia = styled(Box)({
  gridArea: "Transferencia",
})

const Ingreso = styled(Box)({
  gridArea: "Ingreso",
})

const FechaI = styled(Box)({
  gridArea: "FechaI",
})

const FechaF = styled(Box)({
  gridArea: "FechaF",
})

const Detalle = styled(Box)({
  gridArea: "Detalle",
})

const Articulo = styled(Box)({
  gridArea: "Articulo",
})

const Bodega = styled(Box)({
  gridArea: "Bodega",
})

const Cliente = styled(Box)({
  gridArea: "Cliente",
})

const BuscarPickingComponent = () => {
  // EGRESO
  const [inputValue, setInputValue] = useState("")
  // INGRESO
  const [ingresoValue, setIngresoValue] = useState("")
  // TRANSFERENCIA
  const [transferenciaValue, setTransferenciaValue] = useState("")

  const [cliente, setCliente] = useState("")
  const [producto, setProducto] = useState("")
  const [productoDescription, setproductoDescription] = useState("")
  const [productos, setProductos] = useState([])
  const [clienteDescription, setclienteDescription] = useState("")
  const [proveedor, setProveedor] = useState("")
  const [proveedorDescription, setproveedorDescription] = useState("")
  const [motivo, setMotivo] = useState("")
  const [fechaInicial, setFechaInicial] = useState(null)
  const [fechaFinal, setFechaFinal] = useState(null)
  const [detalle, setDetalle] = useState("")
  const [open, setOpen] = useState(false)
  const [estado, setEstado] = useState([])
  const [filtrosMotivo, setFiltrosMotivo] = useState([])
  const [searchAttempted, setSearchAttempted] = useState(false)
  const [clienteSeleccionado, setClienteSeleccionado] = useState(false)
  const navigate = useNavigate()
  const [pickings, setPickings] = useState([])
  const [isFirstTime, setFirstTime] = useState(true)
  const { allFiltrosMotivo } = useGetAllFiltros()
  const { data, isFetchingClientes, errorCliente, refetch: refetchGetAllClientes } = useGetAllClientes()
  // paginación
  const [totalPages, setTotalPages] = useState(1)
  const [page, setPage] = useState(1)
  // filtros
  const [filters, setFilters] = useState({})
  const isFirstRender = useRef(true)
  const debouncedFilters = useDebounce(filters, 500) // ms
  // proveedor select
  const [autoCompleteValueProveedor, setAutoCompleteValueProveedor] = useState("")
  // producto select
  const [autoCompleteValueProducto, setAutoCompleteValueProducto] = useState("")

  const [expanded, setExpanded] = useState(false)

  // impresion
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])

  const handleExpandAccordion = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }
  // Función para manejar cambios en los filtros de la grilla
  const handleGrillaFilterChange = (columnId, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [columnId]: value,
    }))
  }

  const {
    data: dataProductos = [],
    isError: dataProductosError,
    isFetching: isFetchingDataProductos,
    isLoading: isLoadingProductos,
    refetch: refetchGetProductos,
  } = useGetAllProductos()

  const handleChange = (event) => {
    setInputValue(event.target.value)
  }

  const handleChangeIngreso = (event) => {
    setIngresoValue(event.target.value)
  }

  const handleChangeTransferencia = (event) => {
    setTransferenciaValue(event.target.value)
  }

  const handleMotivoChange = (event) => {
    setMotivo(event.target.value)
  }

  const handleEstadoChange = (event) => {
    setEstado(event.target.value)
  }

  const handleProveedorChange = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setProveedor(codigo)
    setproveedorDescription(descripcion)
    setAutoCompleteValueProveedor(selectedValue)
  }

  const handleProductoChange = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setProducto(codigo)
    setproductoDescription(descripcion)
    setAutoCompleteValueProducto(selectedValue)
  }

  const handleFechaInicial = (newFecha) => {
    setFechaInicial(newFecha)
  }

  const handleFechaFinal = (newFecha) => {
    setFechaFinal(newFecha)
  }

  const handleDetalle = (event) => {
    setDetalle(event.target.value)
  }

  const resetAllFilters = () => {
    setFilters({})
  }

  const handleSearch = () => {
    setSearchAttempted(true)
    setFirstTime(false)
    setExpanded(false)
    refetchPickings()
    resetAllFilters()
    setSearchAttempted(false)
  }

  const {
    data: fetchedPickings = [],
    isError: isLoadingPickingsError,
    isFetching: isFetchingPickings,
    isLoading: isLoadingPickings,
    refetch: refetchPickings,
  } = useGetPickingsXFiltro(page)

  const {
    data: fetchedBodegas = [],
    isError: isLoadingBodegasError,
    isFetching: isFetchingBodegas,
    isLoading: isLoadingBodegas,
    refetch: refetchPBodegas,
  } = useGetAllBodegas()

  useEffect(() => {
    setPickings(fetchedPickings.data)
    setTotalPages(fetchedPickings.total)
  }, [fetchedPickings])

  useEffect(() => {
    if (searchAttempted && !isLoadingPickings && !isFetchingPickings && !isFirstTime) {
      console.log("filtros limpioss")
      // resetAllFilters()
    }
  }, [isFetchingPickings, isLoadingPickings, searchAttempted])

  useEffect(() => {
    if (Object.keys(filters).length) {
      console.log("prueba filtrosssss")
      setFilters(filters)
      refetchPickings(debouncedFilters)
      setPage(1)
      resetAllFilters()
    }
  }, [debouncedFilters])

  // Función para manejar cambios en la paginación
  const onPageChange = (newPage) => {
    setPage(newPage) // Actualiza el estado de la página
  }

  useEffect(() => {
    if (isFirstRender.current) {
      // Evita refetch en el primer renderizado
      isFirstRender.current = false
      return
    }
    refetchPickings()
  }, [page])

  useEffect(() => {
    setMotivo(motivo)
  }, [filtrosMotivo])

  useEffect(() => {
    setProveedor(proveedor)
    setproveedorDescription(proveedorDescription)
  }, [proveedor])

  useEffect(() => {
    setProducto(producto)
    setproductoDescription(productoDescription)
  }, [producto])

  useEffect(() => {
    setProductos(dataProductos)
  }, [data])

  function useGetAllProductos() {
    return useQuery({
      queryKey: ["PRODUCTOSPicking"],
      queryFn: async () => {
        let response = await fetchwrapper(`/picking/getArticulos`)
        response = await response.json()

        console.log("alerta", response.data)

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  function useGetAllClientes() {
    return useQuery({
      queryKey: ["CLIENTESPicking"],
      queryFn: async () => {
        let response = await fetchwrapper(`/picking/getClientes`)
        response = await response.json()

        console.log("alerta", response.data)

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  function useGetAllBodegas() {
    return useQuery({
      queryKey: ["BODEGASPICKING"],
      queryFn: async () => {
        let response = await fetchwrapper(`/picking/getAllBodegas`)
        response = await response.json()

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  function useGetPickingsXFiltro(page) {
    return useQuery({
      queryKey: ["pickingsXFiltro", page],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            tranumero: inputValue,
            tradocumento: transferenciaValue,
            pctacodigo: ingresoValue,
            bodcodigo: filtrosMain.bodcodigo.value,
            fechaInicial,
            fechaFinal,
            artcodigo: filtrosMain.artdescri.value,
            clipicking: filtrosMain.clipicking.value,
            tradescripcion: detalle,
            page,
            filters,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        // send api request here
        let response = await fetchwrapper("/picking/getPickings", options)
        response = await response.json()
        return response
      },
      refetchOnWindowFocus: false,
      enabled: false,
      staleTime: Infinity,
    })
  }

  function useGetAllFiltros() {
    return useQuery({
      queryKey: ["solicitudDeEgresoFiltrosSearch"],
      queryFn: async () => {
        try {
          const response = await fetchwrapper("/solicitudDeEgreso/getAllFiltros")
          const data = await response.json()
          if (!data || !data.data) {
            setFiltrosMotivo([])
            return []
          }

          setFiltrosMotivo(data.data)

          return data.data
        } catch (error) {
          console.error("Error fetching data:", error)
          setFiltrosMotivo([])
          return []
        }
      },
      refetchOnWindowFocus: false,
      enabled: true,
    })
  }

  const handleSelect = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setCliente(codigo)
    setclienteDescription(descripcion)
    setClienteSeleccionado(true)
  }

  const handleSetFiltros = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }))

  const [filtrosMain, setFiltros] = useState({
    clipicking: "",
    artdescri: "",
    bodcodigo: "",
  })

  const handleOpenModal = () => {
    setInfoGenerada(fetchedPickings.data) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const {
    data: fetchedUsuarios = [],
    isError: isLoadingUsuariosoError,
    isFetching: isFetchinUsuarios,
    isLoading: isLoadingUsuarios,
  } = useGetUsuarios()

  function useGetUsuarios() {
    return useQuery({
      queryKey: ["USUARIOSPicking"],
      queryFn: async () => {
        let response = await fetchwrapper(`/pickingSugerido/getUsuarios`)
        response = await response.json()

        console.log("alerta", response.data)

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  return (
    <PickingContextProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <BackIcon />
          <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
              <CustomTooltip title={"Ejecutar"}>
                <Button style={{ fontSize: "0.9vw" }} onClick={handleSearch}>
                  <img src={EjecutarIcon} alt="Crear" style={{ width: "40px" }} />
                </Button>
              </CustomTooltip>
            </div>
            <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
              <CustomTooltip title={"Crear Picking"}>
                <Button
                  style={{ fontSize: "0.9vw" }}
                  onClick={() => {
                    navigate("/home/dashboard/Picking/crear")
                  }}
                >
                  <img src={CrearIcon} alt="Crear" style={{ width: "40px" }} />
                </Button>
              </CustomTooltip>
            </div>
          </div>
          <div style={{ paddingBottom: "10px" }}>
            <Accordion
              expanded={expanded}
              onChange={handleExpandAccordion}
              slotProps={{ heading: { component: "h2" } }}
            >
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                  Criterios de búsqueda
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Container>
                  <Egreso>
                    <InputLabel>Egreso</InputLabel>
                    <TextField value={inputValue} onChange={handleChange} fullWidth />
                  </Egreso>
                  <Transferencia>
                    <InputLabel>Transferencia</InputLabel>
                    <TextField value={transferenciaValue} onChange={handleChangeTransferencia} fullWidth />
                  </Transferencia>
                  <Ingreso>
                    <InputLabel>Ingreso</InputLabel>
                    <TextField value={ingresoValue} onChange={handleChangeIngreso} fullWidth />
                  </Ingreso>
                  <FechaI>
                    <InputLabel>Fecha Inicial</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={fechaInicial}
                        format="DD/MM/YYYY"
                        sx={{ width: "100%" }}
                        dateFormat="yyyy-MM-dd hh:mm:ss.SSSSSS"
                        timeFormat="HH:mm:ss.SSSSSS"
                        onChange={handleFechaInicial}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FechaI>
                  <FechaF>
                    <InputLabel>Fecha Final</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={fechaFinal}
                        sx={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        onChange={handleFechaFinal}
                        dateFormat="yyyy-MM-dd hh:mm:ss.SSSSSS"
                        timeFormat="HH:mm:ss.SSSSSS"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FechaF>
                  <Detalle>
                    <InputLabel>Detalle</InputLabel>
                    <TextField value={detalle} onChange={handleDetalle} fullWidth />
                  </Detalle>
                  <Articulo>
                    <CustomAutocomplete
                      label="Artículo"
                      selectedOption={filtrosMain.artdescri}
                      setSelectedOption={(v) => handleSetFiltros("artdescri", v)}
                      options={dataProductos}
                    />
                  </Articulo>
                  <Cliente>
                    <CustomAutocomplete
                      label="Cliente"
                      selectedOption={filtrosMain.clipicking}
                      setSelectedOption={(v) => handleSetFiltros("clipicking", v)}
                      options={data}
                    />
                  </Cliente>
                  <Bodega>
                    <CustomAutocomplete
                      label="Bodega"
                      selectedOption={filtrosMain.cliente}
                      setSelectedOption={(v) => handleSetFiltros("bodcodigo", v)}
                      options={fetchedBodegas}
                    />
                  </Bodega>
                </Container>
              </AccordionDetails>
            </Accordion>
          </div>
          <GridPickingSearch
            fetchedInfo={pickings}
            isLoadingInfoError={isLoadingPickingsError}
            isLoadingInfo={isLoadingPickings}
            isFetchingInfo={isFetchingPickings}
            searchAttempted={searchAttempted}
            setSolicitudesIngresos={setPickings}
            refetch={refetchPickings}
            totalPages={totalPages}
            onPageChange={onPageChange}
            onFilterChange={handleGrillaFilterChange}
          />
        </div>
      </ThemeProvider>
    </PickingContextProvider>
  )
}

export default BuscarPickingComponent
